import { graphql } from "@/graphql/generated/gql";
import {
  ReactivateMunicipalPropertyMutation,
  ReactivateMunicipalPropertyMutationVariables,
} from "@/graphql/generated/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";

export const REACTIVATE_MUNICIPAL_PROPERTY_MUTATION_DOCUMENT: TypedDocumentNode<
  ReactivateMunicipalPropertyMutation,
  ReactivateMunicipalPropertyMutationVariables
> = graphql(/* GraphQL */ `
  mutation ReactivateMunicipalProperty($id: ID!) {
    reactivateMunicipalProperty(id: $id) { id archivedAt }
  }
`);
